import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
  root: {
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
    scrollX: 'none',

  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

let id = 0;
function createData(name, calories, fat, carbs, protein) {
  id += 1;
  return { id, name, calories, fat, carbs, protein };
}

function CustomizedTable(props) {
  const { classes, image } = props;

  return (
    <Paper className={classes.root}>
      <AppBar position="static">
        <Typography variant="title" color="inherit">Image Information</Typography>
      </AppBar>
      {image && image.fields && (
          <div style={{ textAlign: 'left', paddingLeft: '15px', paddingTop: '15px' }}>
              <Typography variant="headline">Resolution: ({image.fields.x_res}x{image.fields.y_res})</Typography>
              <Typography variant="headline">Ingestion Date: {image.fields.created_at}</Typography>
          </div>
      )}
    </Paper>
  );
}

CustomizedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(CustomizedTable);



// WEBPACK FOOTER //
// ./src/components/image_info.jsx